<div class="row g-4">
    @if (access.throughput) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Overall Throughput Volumes">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadThroughput"
                    [palette]="palettes.throughput"
                    centerText="Total Throughput"
                    formatMode="decimal"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
        <div class="col-12 col-lg-6">
            <app-dashboard-tiles [items]="throughputTiles"></app-dashboard-tiles>
        </div>
    }

    @if (access.facilityUtilization) {
        @for (chart of usageCharts; track chart.scoreType) {
            <div class="col-12 col-lg-4">
                <app-dashboard-card [title]="chart.scoreType | capitalCase">
                    <app-doughnut-chart
                        [from]="from"
                        [to]="to"
                        [loadData]="chart.loadData"
                        [palette]="palettes.facilityUtilization"
                        [centerText]="chart.scoreType | capitalCase"
                        [responsive]="false"
                    ></app-doughnut-chart>
                </app-dashboard-card>
            </div>
        }
    }
</div>
